import { render } from "./ResetPasswordModal.vue?vue&type=template&id=b37688ee&scoped=true"
import script from "./ResetPasswordModal.vue?vue&type=script&lang=js"
export * from "./ResetPasswordModal.vue?vue&type=script&lang=js"

import "./ResetPasswordModal.vue?vue&type=style&index=0&id=b37688ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b37688ee"]])

export default __exports__